module.exports = __webpack_public_path__ + "static/img/01-友链4.c58c864.png";


//////////////////
// WEBPACK FOOTER
// ./public/pc/01-友链4.png
// module id = YvGG
// module chunks = 14